import { calculateTotal } from '@calculations/price/utilities/total';
import { SnapRoundingOptionsCustom } from '@calculations/round';
import { Decimal } from '@snap-types/types/decimal';
import { WritableQuoteBuilderStateType } from '@ui/features/quote-builder/types/state';

import { getQuotePriceOrThrow } from '../../utilities/action-guards';

export function onServiceChargeQuantityChange(
  state: WritableQuoteBuilderStateType,
  params: {
    quoteLineUuid: string;
    quotePriceUuid: string;
    quantity: Decimal;
  },
) {
  const quotePrice = getQuotePriceOrThrow(
    state,
    params.quoteLineUuid,
    params.quotePriceUuid,
  );

  quotePrice.quantity = params.quantity;
  quotePrice.userQuantity = params.quantity;

  quotePrice.totalPrice = calculateTotal(
    quotePrice.unitPrice,
    params.quantity,
    SnapRoundingOptionsCustom(state),
  );
}
